import React, {useState, useEffect} from 'react';
import { Page, Icon, Link,  Button, Swiper as SwiperComponent, SwiperSlide , f7 } from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH, IMG_URL } from '../globals';

const SearchEventOrderPage = () => {
  const [eventdata, setEventDetails] = useState([]); 
  const [searchKey, setSearchKey] = useState({}); 

  useEffect(() => {
    if(Object.keys(searchKey).length > 0){
      axios.get(API_BASE_URL + 'searcheventbyname', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
          search : searchKey
        }
      })
      .then(response => {
        console.log(response.data.data);
        setEventDetails(response.data.data);
      })
      .catch(error => {console.log(error);
        setEventDetails([]);  });
    }else{
      setEventDetails([]);
    }


  }, [searchKey]);

  // const searchByName = (e) =>{
  //   e.preventDefault();
  //   axios.get(API_BASE_URL + 'restsearchbyname', {
  //     headers: {
  //       'Authorization': 'Basic ' + API_AUTH
  //     },
  //     params: {
  //       search : searchKey
  //     }
  //   })
  //   .then(response => {setRestDetails(response.data);
  //     console.log(response.data);
  //   })
  //   .catch(error => {console.log(error);
  //     setRestDetails([]);    });
  // }
  
  return (
    <Page className='bg-white'>
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="custom-container p-0">
              <div className="container-lg header-panel p-0">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Event Search</h2>                
              </div>
            </div>
          </header>
        <section className="search-section section-t-space profile-form mt-3">
          <div className="custom-container p-0">
            <form className="auth-form search-head" >
              <div className="form-group">
                <div className="form-input w-100">
                  <input type="text" className="form-control search" onChange={(e) => setSearchKey(e.target.value) }  id="inputusername" placeholder="Event name, Restaurant.." autoFocus  />
                  <Icon ios="material:search" aurora="material:search" md="material:search" size={22}></Icon>
                </div>              
              </div>
            </form>
          </div>
        </section>

        <section className="section-t-space bg-white mt-0">
          <div className='container p-0'>
            <div className='row gy-3 '>
                {eventdata.length > 0 ? (
                  eventdata.map(item => (
                    <div className='bid-web-view-div '>
                      <a href={`/eventdetail/${item.id}/`}>
                      <div className="vertical-product-box order-box">
                        <div className="vertical-box-img">
                          <img className="img-fluid img" src={require("./../images/events.jpg")} alt="vp1" />
                        </div>
                        <div className="vertical-box-details">
                          <div className="vertical-box-head">
                            <div className="restaurant">
                              <h5 className="dark-text">{item.event_name}</h5>
                              <h5 className={ item.order_status==5 ? 'text-danger':'text-success'}>{item.event_status_text}</h5>
                            </div>
                            <h6 className="food-items mb-2"><Icon ios="material:location_on" aurora="material:location_on" md="material:location_on" className='text-success text-3'/> {item.add_lin_1} {item.add_lin_2} {item.city} {item.state} {item.zip_code}</h6>                    
                          </div>
                          <div className="reorder">
                            <h6 className="rating-star">
                              <ul className="timing">
                                <li><Icon ios="material:groups" aurora="material:groups" md="material:groups" className='text-muted text-4'/> {item.event_adult_size + item.event_kids_size} </li>
                                <li><Icon ios="material:event" aurora="material:event" md="material:event" className='text-muted text-4'/> {item.event_date}</li>
                                {/* <li className="text-success"> {item.order_status}</li> */}
                                {/* {item.event_status == 1 ?(
                                  <li><a fill small className="" href={`/edit_event/${item.id}/`}>  Edit </a></li>                    

                                ):'' } */}
                              </ul>  
                            </h6>
                          </div>

                        </div>
                      </div>
                      </a>
                    </div>           
                  ))
                  ) : (
                    <div className="custom-container p-1">
                      <div className="empty-tab">
                        {/* <h2>Search Event !!</h2> */}
                        <h5 className="mt-3">Search Event !!</h5>
                      </div>
                    </div>
                  )}
            </div>
          </div>
        </section>
      </div>
    </div>
  </Page>
  );
};

export default SearchEventOrderPage;